import { Routing } from "helpers/routing"
import React, { createContext } from "react"

const GamingGearContext = createContext<{
  params?: Routing.GamingGearParams
}>({})

export { GamingGearContext }
